import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies

const InputRadio = ({
  children, onChange, required, name, value, checked,
}) => {
  const handleOnChange = (e) => onChange(e.target.value);

  return (
    <label className="radio-label">
      <input
        type="radio"
        name={name}
        className="radioInput"
        onChange={handleOnChange}
        required={required}
        value={value}
        checked={checked}
      />
      <span>{children}</span>
    </label>
  );
};

InputRadio.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.string,
};

InputRadio.defaultProps = {
  checked: false,
  children: null,
  name: '',
  onChange: () => { },
  required: false,
  value: '',
};
export default InputRadio;
